import * as tslib_1 from "tslib";
import { Component, Inject } from "vue-property-decorator";
// import { H3RadioList, H3CheckboxList } from "h3-mobile-vue";
import { H3CheckboxList } from "./../../h3-mobile-vue/components/h3-checkbox/index.js";
import { DropdownControl } from "../control/dropdown-control";
import ControlBack from "@cloudpivot/form/src/common/directives/control-back";
let Dropdown = class Dropdown extends DropdownControl {
    constructor() {
        super(...arguments);
        this.showModal = false;
        // 将用户输入的自定义选项存储在session中
        this.customeInputSessionKey = `mobile-custome-dropdown-input${Date.now().valueOf()}`;
        // 是否首次计算
        this.firstComputed = true;
        // 选项默认是否为空项
        this.defaultNull = false;
    }
    show() {
        this.showModal = true;
        this.getOPt();
    }
    close() {
        this.showModal = false;
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    onChange(val) {
        if (val) {
            const temp = val.slice().pop();
            // 如果新的值不存在下拉选项里面需要把他存储起来
            if (temp && !this.options.includes(temp)) {
                sessionStorage.setItem(this.customeInputSessionKey, temp);
            }
            this.ctrl.value = [temp];
        }
        else {
            this.ctrl.value = null;
        }
    }
    handleValueChange(value) {
        if (Array.isArray(value)) {
            value = value.filter((x) => !!x);
        }
        super.handleValueChange(value);
    }
    getOPt() {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield _super("getOptions").call(this);
            // 记录首次是否有数据，判断是否默认是空数据
            if (this.firstComputed) {
                this.defaultNull = !this.options.length;
                this.firstComputed = false;
            }
            // 为空项
            if (this.defaultNull) {
                this.options = [];
            }
            // 获取完options之后，将用户输入自定义选项追加进去
            const inputOpt = sessionStorage.getItem(this.customeInputSessionKey);
            if (inputOpt) {
                if (!this.options.includes(inputOpt)) {
                    this.options.unshift(inputOpt); // 去重添加
                }
                this.$nextTick(() => {
                    // 重新赋值给下拉checkbox
                    const refs = this.$refs.h3CkListRef;
                    const selected = (refs.selected || []).slice().pop();
                    refs.selected = [selected];
                });
            }
        });
    }
    clearOption(change) {
        this.options = [];
        this.ctrl.value = null;
    }
};
tslib_1.__decorate([
    Inject()
], Dropdown.prototype, "layoutTypeFn", void 0);
Dropdown = tslib_1.__decorate([
    Component({
        name: "dropdown",
        components: {
            H3CheckboxList,
        },
        directives: {
            ControlBack,
        },
        mixins: [],
    })
], Dropdown);
export default Dropdown;
